const menu = (state = [], action) => {
  switch (action.type) {
    case "SET_SYSTEM_TRAY_MENU":
      return action.menu
    case "PUSH_SYSTEM_TRAY_MENU_ITEM":
      return [...state, action.menuItem]
    case "SET_MENU_ITEM": {
      return action.menu
    }
    case "REMOVE_MENU_ITEM": {
      return action.menu
    }
    default:
      return state
  }
}

export default menu
